<template>
  <div>
    <div class="custom-service-quote">
        <div class="custom-show-service">
            <span class="text-quote">Service type</span>
            <span class="separator-type">|</span>
            <span class="text-quote">{{service_types.filter(item=> item.id.toString() === request_quotation.service_type.toString())[0].name || '' }}</span>
        </div>
    </div>
    <div class="title custom-title mb-1">Routing Details</div>
    <b-card class="b-card-bg" v-if="request_quotation.service_type.toString() == '6' ||request_quotation.service_type.toString() == '5'">
      <div class="custom-routing-docs">
        <div class="custom-row-docs">
          <div class="custom-content-row">
            <div class="custom-text-end">Quotation No.</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
              {{ request_quotation.quotation ? request_quotation.quotation.toString().startsWith("WR1") ? request_quotation.quotation : '': ''}}
            </div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">Handing type</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
              {{ request_quotation.shippingType ?  transport_types.filter(item=> item.id.toString() === request_quotation.shippingType.toString())[0].name : "" }}
            </div>
          </div>
          <div class="custom-content-row">
            <div v-if="request_quotation.service_type.toString() == '5'" class="custom-text-end">Empty container deport</div>
            <div v-if="request_quotation.service_type.toString() == '5'" class="separator">|</div>
            <div v-if="request_quotation.service_type.toString() == '5'" class="custom-text-start">
              {{request_quotation.deport ? locations.filter(item=> item.id.toString() === request_quotation.deport.toString())[0].name : "" }}
            </div>
          </div>
        </div>
        <div class="custom-row-docs">
          <div class="custom-content-row">
            <div class="custom-text-end">Pick up address</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
              {{ request_quotation.pickup_location ? locations.filter(item=> item.id.toString() === request_quotation.pickup_location.toString())[0].name : "" }}
            </div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">Pick up contact person</div>
            <div class="separator">|</div>
            <div class="custom-text-start">{{( request_quotation.pickUpContact.name? request_quotation.pickUpContact.name :'') + ' ' + (request_quotation.pickUpContact.phone ? request_quotation.pickUpContact.phone : '') }}</div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">Pick up date</div>
            <div class="separator">|</div>
            <div class="custom-text-start">{{ (request_quotation.pickUpDate ? request_quotation.pickUpDate :'') + ' ' + (request_quotation.pickUpTime ? request_quotation.pickUpTime : '') }}</div>
          </div>
        </div>
        <div class="custom-row-docs">
          <div class="custom-content-row">
            <div class="custom-text-end">Delivery address</div>
            <div class="separator">|</div>
            <div class="custom-text-start"> {{request_quotation.delivery_location ? locations.filter(item=> item.id.toString() === request_quotation.delivery_location.toString())[0].name : "" }}</div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">Delivery contact person</div>
            <div class="separator">|</div>
            <div class="custom-text-start">{{( request_quotation.deliveryContact.name ? request_quotation.deliveryContact.name: '') +' ' + (request_quotation.deliveryContact.phone ? request_quotation.deliveryContact.phone : '')}}</div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">Delivery date</div>
            <div class="separator">|</div>
            <div class="custom-text-start">{{ (request_quotation.deliveryDate ? request_quotation.deliveryDate : "") + ' ' + (request_quotation.deliveryTime ? request_quotation.deliveryTime : '')}}</div>
          </div>
        </div>
      </div>
    </b-card>
    <b-card class="b-card-bg" v-if="request_quotation.service_type.toString() == '3'">
      <div class="custom-routing-docs-lcl">
        <div class="custom-row-docs-lcl">
          <div class="custom-content-row">
            <div class="custom-text-end">Vessel/Voyage</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
              {{ request_quotation.vessel || "" }}
            </div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">ETD</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
              {{ request_quotation.etd || '' }}
            </div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">ETA</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
                {{ request_quotation.eta || '' }}
            </div>
          </div>
          <div class="custom-content-row">
            
          </div>
        </div>
        <div class="custom-row-docs-lcl">
          <div class="custom-content-row">
            <div class="custom-text-end">Quotation No.</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
              {{ request_quotation.quotation ? request_quotation.quotation.toString().startsWith("WR1") ? request_quotation.quotation : '': ''}}
            </div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">Transit Port</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
                {{ request_quotation.transit_port ?  ports.filter(item=> item.code.toString() === request_quotation.transit_port.toString())[0].name : "" }}
            </div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">Origin Port</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
                {{ request_quotation.pol_port ?  ports.filter(item=> item.code.toString() === request_quotation.pol_port.toString())[0].name : "" }}
            </div>
          </div>
          <div class="custom-content-row">
            <div class="custom-text-end">Delivery Port</div>
            <div class="separator">|</div>
            <div class="custom-text-start">
                {{ request_quotation.pod_port ?  ports.filter(item=> item.code.toString() === request_quotation.pod_port.toString())[0].name : "" }}
            </div>
          </div>
        </div>
        
      </div>
    </b-card>
  </div>
</template>

<script>

import { mapState } from "vuex";
export default {

    components: {},
  props: {
    request_quotation: { default: null },
  },
  computed: {
    ...mapState("masterData", [
            "service_types",
            "ports",
            "incoterms",
            "cont_types",
            "goods_types",
            "transport_types",
            "deports_locations",
            "deports",
            "business_types",
            "customs_types",
            "shipping_lines",
            "regions",
            "companyItems",
            "fee_types",
            "handed_types",
            "locations"
        ]),
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.separator-type{
    font-size:1.7rem;
    color:#797979
}
.text-quote{
    font-size:1rem;
    font-weight:600;
    color:#000000
}
.custom-text-end {
  text-align: end;
  width: 100%;
  font-size: 1.05rem;
  font-weight: 600;
}
.custom-text-start {
  text-align: start;
  width: 100%;
}
.custom-routing-docs {
  background-color: white;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
}
.custom-routing-docs-lcl {
  background-color: white;
  display: grid;
  grid-template-rows: 1fr 1fr;
}
.separator {
  color: #b1c9c5;
  padding: 0 2rem;
  font-size: 1.5rem;
}
.custom-content-row {
  padding: 0.9rem;
  display: grid;
  justify-items: center;
  grid-template-columns: 3fr 1fr 3fr;
  align-items: center;
}
.custom-row-docs {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  border-bottom: 1px solid #e2f2ef;
  justify-items: center;
  align-items: center;
}
.custom-row-docs-lcl {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  border-bottom: 1px solid #e2f2ef;
  justify-items: center;
  align-items: center;
}
.custom-view-img {
  width: 100%;
  max-height: 3.2rem;
  height: 3.2rem;
}
.custom-view-container-img {
  max-width:3.2rem;
  margin: 0 auto;
  cursor: pointer;
}
.custom-service-quote{
    width:20rem;
    background-color: #e2f2ef;
    padding:0.7rem;
    margin-bottom:2rem;
    margin-top:1rem;
}
.custom-show-service{
    display:flex;
    width: 100%;
    justify-content: space-around;
}
</style>
